import { useContext } from 'react';
import { Web3DevHubContext } from './context';

export const useDevHub = () => {
    const context = useContext(Web3DevHubContext);
    if (!context) {
        throw new Error('useDevHub must be used within a Web3DevHubProvider');
    }
    return context;
}